
const actionPrefix = 'app/toasts';

export const CLEAR_STATE = `${actionPrefix}/CLEAR_STATE`;

export const SHOW_TOAST = `${actionPrefix}/SHOW_TOAST`;

